export const distance = 'distance';
export const jibun = 'jibun';
export const area = 'area';
export const chargeType = {
    distance,
    jibun,
    area,
};
